<template>
  <div>
    <b-card>  
        <form v-on:submit.prevent="formSubmitted" enctype="multipart/form-data">
          
          <!-- Full Name -->
          <b-row>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="First Name *" label-for="first-name">
                  <b-form-input
                    id="first-name"
                    class="text-capitalize"
                    v-model="candidateData.firstName"
                    autofocus
                    ref="firstName"
                    trim
                    placeholder="John"
                    @input="clearError('firstName')"
                  />
                <small v-if="error.firstName" class="text-danger">{{ error.firstName }}</small>
                  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="Last Name *" label-for="last-name">
                  <b-form-input
                    id="last-name"
                    class="text-capitalize"
                    v-model="candidateData.lastName"
                    autofocus
                    trim
                    placeholder="Doe"
                    ref="lastName"
                    @input="clearError('lastName')"
                  />

                <small v-if="error.lastName" class="text-danger">{{ error.lastName }}</small>  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Candidatename -->
             
                <b-form-group label="Company Name *" label-for="companyname">
                  <b-form-input
                    id="company-name"
                    class="text-capitalize"
                    v-model="candidateData.companyName"
                    trim
                    ref="companyName"
                    @input="clearError('companyName')"
                  />
                  <small v-if="error.companyName" class="text-danger">{{ error.companyName }}</small>
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Company -->

              <b-form-group label="Job Title *" label-for="job-title">
                <b-form-input id="job-title" class="text-capitalize" v-model="candidateData.jobTitle" ref="jobTitle" trim @input="clearError('jobTitle')" />
                <small v-if="error.jobTitle" class="text-danger">{{ error.jobTitle }}</small>
              </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
              
                <b-form-group label="Email *" label-for="email">
                  <b-form-input
                    id="email"
                    class="text-lowercase"
                    v-model="candidateData.email"
                    trim
                    ref="email"
                    @input="runCheck"
                  />

                  <small v-if="error.email" class="text-danger">{{ error.email }}</small>   
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Company -->
              
                <b-form-group label="Contact *" label-for="contact">
                  <b-form-input
                    id="contact"
                    v-model="candidateData.contact"
                    ref="contact"
                    trim
                    @input="runCheck"
                  />
                  <small v-if="error.contact" class="text-danger">{{ error.contact }}</small>
                  <small class="text-primary" @click="checkCandidateExist">{{ checkButton }}</small>
                </b-form-group>
             
            </b-col>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="CTC *" label-for="ctc">
                  <b-form-input
                    id="ctC"
                    v-model="candidateData.ctc"
                    type="number"
                    step=".01"
                    autofocus
                    trim
                    ref="ctc"
                    placeholder="CTC in Lacs"
                    @input="clearError('ctc')"
                  />
                  <small v-if="error.ctc" class="text-danger">{{ error.ctc }}</small>
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Candidatename -->
              <b-form-group label="Expected CTC *" label-for="expected-ctc">
                <b-form-input
                  id="expected-ctc"
                  type="number"
                  step=".01"
                  v-model="candidateData.expectedCTC"
                  autofocus
                  trim
                  ref="expectedCTC"
                  placeholder="Expected CTC in Lacs"
                  @input="clearError('expectedCTC')"
                />
                <small v-if="error.expectedCTC" class="text-danger">{{ error.expectedCTC }}</small>
              </b-form-group>
            </b-col>
            
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
                <b-form-group label="Experience *" label-for="experience">
                  <b-form-input
                    id="experience"
                    v-model="candidateData.exp"
                    type="number"
                    step=".01"
                    trim
                    ref="exp"
                    placeholder="Experience in Years"
                    @input="clearError('exp')"
                  />           
                  <small v-if="error.exp" class="text-danger">{{ error.exp }}</small>       
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
                <b-form-group label="Relevant Experience" label-for="rel-experience">
                  <b-form-input
                    id="rel-experience"
                    v-model="candidateData.relevant_exp"
                    type="number"
                    step=".01"
                    trim
                    ref="rel-exp"
                    placeholder="Relevant Experience in Years"
                  />           
                  <!-- <small v-if="!candidateData.exp" class="text-danger">{{ error.exp }}</small>        -->
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
              
                <b-form-group label="Notice Period *" label-for="notice-period">
                  <!--<b-form-input
                    id="notice-period"
                    v-model="candidateData.noticePeriod"
                    type="number"
                    step=".01"
                    trim
                    ref="noticePeriod"
                    placeholder="In Days"
                  />-->
                  <v-select
                    id="notice-period"
                    label="value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="candidateData.noticePeriod"
                    :options="noticePeriodOptions"
                    :reduce="(option) => option.text"
                    @input="clearError('noticePeriod')"
                />
                <small v-if="error.noticePeriod" class="text-danger">{{ error.noticePeriod }}</small>
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="City *" label-for="city">
                  <v-select
                    v-model="candidateData.selectedCity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    ref="city"
                    @input="clearError('selectedCity')"
                  />
                </b-form-group>
                <small v-if="error.selectedCity" class="text-danger">{{ error.selectedCity }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="Preferred Location *" label-for="pre-city">
                  <v-select
                    v-model="candidateData.preferredCities"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    :close-on-select="false"
                    multiple
                    ref="preCity"
                    @input="clearError('preferredCities')"
                  />
                </b-form-group>
                <small v-if="error.preferredCities" class="text-danger">{{ error.preferredCities }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Country -->
                <b-form-group
                  label="Skills *"
                  label-for="skills"
                >
                  <!--<b-form-input
                    id="skills-selected"
                    v-model="candidateData.skillsSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    trim
                    ref="skills"
                  />-->
                  <v-select
                    v-model="candidateData.skillsSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="skillsOptions"
                    :close-on-select="false"
                    multiple
                    ref="skills"
                    @input="clearError('skillsSelected')"
                  />
                  <small v-if="error.skillsSelected" class="text-danger">{{ error.skillsSelected }}</small>
                </b-form-group>
            </b-col>

            <b-col md="6" xl="6" lg="6">
              <!-- Candidate Role -->

              <b-form-group label="Qualification *" label-for="qualification">
                <v-select
                  id="qual"
                  v-model="candidateData.qualification"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="qualifications"
                  label="title"
                  required
                  ref="qualification"
                  @input="clearError('qualification')"
                />
              </b-form-group>
              <small v-if="error.qualification" class="text-danger">{{ error.qualification }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->

              <b-form-group label="Source *" label-for="source">
                <v-select
                  v-model="candidateData.source"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sources"
                  input-id="source"
                  label="title"
                  required
                  ref="source"
                  @input="clearError('source')"
                />
              </b-form-group>
              <small v-if="error.source" class="text-danger">{{ error.source }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Candidate Role -->
                <b-form-group
                  label="DOB"
                  label-for="dob"
                >
                  <!--<b-form-datepicker 
                    id="dob" 
                    v-model="candidateData.dob" 
                    class="mb-1"
                    :show-decade-nav=true
                    locale="en-IN" />-->
                  <flat-pickr
                    class="form-control"
                    id="dob" 
                    v-model="candidateData.dob" 
                    
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->

              <b-form-group label="Gender *" label-for="gender">
                <v-select
                  v-model="candidateData.genderSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genderOptions"
                  input-id="gender"
                  label="title"
                  required
                  ref="gender"
                  @input="clearError('genderSelected')"
                />
              </b-form-group>
              <small v-if="error.genderSelected" class="text-danger">{{ error.genderSelected }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->
              <b-form-group label="Upload Resume *" label-for="resume">
                <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  id="cv-file"
                  name="cv-file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown"
                  @change="openFile(); clearError('file')"
                  v-model="candidateData.file"
                  type="file"
                  ref="file"
                />
              </b-form-group>
              <small v-if="error.file" class="text-danger">{{ error.file }}</small>
              <small v-if="file && file.size > 1690000" class="text-danger"> File Size Should be less than 1.5 mb </small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->
              <b-form-group label="Remarks" label-for="remarks">
                <b-form-textarea
                  id="textarea-default"
                  placeholder="Add Remark"
                  rows="3"
                  v-model="candidateData.remarks"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              value="submit"
              id="submit"
              
            >
              <span v-if="!loading">Add</span>
              <b-spinner small v-else/>
            </b-button>
            <!--<b-button
              variant="primary"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              <span class="sr-only">Loading...</span>
            </b-button>-->
            <b-button @click="closeToggle">
              Cancel
            </b-button>
          </div>
        </form>
      </b-card>  
      <!-- modal -->
    <b-modal
      ref="can-remarks-check"
      title="Candidate Hygiene Issue!!!"
      cancel-variant="outline-secondary"
      ok-title="ACCEPT"
      cancel-title="Cancel"
      centered
      @ok="confirmRemarks"
    >
      <div class="d-block text-center">
        
        <b-list-group flush>
          <b-list-group-item v-for="(r, index) in remarks" :key="index"><span class="text-danger">{{ r }}</span></b-list-group-item>
        </b-list-group>
      
        
        <h5 class="mt-1">Make sure this candidate has been added as an exception after discussing with client!!!</h5>
        <h5>Please confirm do you agree to proceed with this candidate?</h5>
      </div>
      
    </b-modal>

    <!--</template>
  </b-sidebar>-->
  </div>
</template>

<script>
import {

  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BSpinner,
  BRow,
  BCol,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BButton, BSidebar, VBToggle, BModal, BListGroup, BListGroupItem, BCard
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "vue";
import { required, alphaNum, email } from "@validations";
//import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from 'vue-ripple-directive'
import vSelect from "vue-select";
import countries from "@/@fake-db/data/other/countries";
//import store from "@/store";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CandidateService from '@/services/candidate-service'
import JobService from '@/services/job-service'
import jobTimelineService from '@/services/job-timeline'
import flatPickr from 'vue-flatpickr-component'
import emailTemplates from "@/services/email-templates";
import mailService from "@/services/mail-service"
import locationService from "@/services/location-service";
import adminConfigService from "@/services/admin-config-service";
//import firebaseMessaging from '@/firebase'
//import UserService from "@/services/user-service";

export default {
  components: {
    BSidebar, BButton, VBToggle,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BSpinner,
    vSelect,
    BRow,
    BCol,
    BFormDatepicker,
    BFormFile,
    BFormTextarea,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    BModal,
    BListGroup, BListGroupItem, BCard
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  /*model: {
    prop: "isAddNewCandidateSidebarActive",
    event: "update:is-add-new-candidate-sidebar-active",
  },
  props: {
    isAddNewCandidateSidebarActive: {
      type: Boolean|String,
      required: true,
    },
    isEventHandlerSidebarActive: {
      type: Boolean,
      required: true,
    },
    /*roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },*/
  props: {
    //jobData: Object,
    //isRecruiter: Boolean
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      selectedCity: { title: "Pune" },
      preferredCities: '',
      //selectedState: { title: "Maharashtra" },
      cities: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Remote"}, {"title": "PAN INDIA"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
      //response: 'hi there',
      //jobInfo: this.jobData,
      jId: '',
      // genderOptions: [
      //   { title: "Male" },
      //   { title: "Female" },
      //   { title: "Transgender" },
      //   { title: "Non-binary/non-conforming" },
      //   { title: "Prefer not to respond" },
      // ],
      genderOptions: [
        { title: "Male" },
        { title: "Female" },
        { title: "LGBQ" },
        { title: "Transgender" },
      ],
      qualifications: [],
      specialization: [{ title: "Agriculture" }, 
        { title: "Automobile" }, 
        { title: "Aviation" }, 
        { title: "Bio-Chemistry/Bio-Technology" }, 
        { title: "Biomedical" }, 
        { title: "Ceramics" }, 
        { title: "Chemical" }, 
        { title: "Civil" }, 
        { title: "Computers" }, 
        { title: "Electrical" }, 
        { title: "Electronics/Telecommunication" }, 
        { title: "Energy" }, 
        { title: "Environmental" }, 
        { title: "Instrumentation" }, 
        { title: "Marine" }, 
        { title: "Mechanical" }, 
        { title: "Metallurgy" }, 
        { title: "Mineral" }, 
        { title: "Mining" }, 
        { title: "Nuclear" }, 
        { title: "Paint/Oil" }, 
        { title: "Petroleum" }, 
        { title: "Plastics" }, 
        { title: "Production/Industrial" }, 
        { title: "Textile" }, 
        { title: "OtherSpecialization" }],
      sources: [
        { title: "Naukri" },
        { title: "Monster" },
        { title: "LinkedIn" },
        { title: "Indeed" },
        { title: "Shine" },
        { title: "TimesJobs" },
        { title: "IIMJobs" },
        { title: "Glassdoor" },
        { title: "FreshersWorld" },
        { title: "Other" },
        { title: "Train N Hire" },
        { title: "Internal" },
        { title: "Referenced" },
        { title: "MassMailer" },
      ],
      noticePeriodOptions: [
        { value: 0, text: 0 },
        { value: 15, text: 15 },
        { value: 30, text: 30 },
        { value: 45, text: 45 },
        { value: 60, text: 60 },
        { value: 90, text: 90 },
      ],
      candidateData: {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact: "",
        jobTitle: "",
        selectedCity: "",
        ctc: null,
        expectedCTC: null,
        exp: null,
        noticePeriod: null,
        skillsSelected: "",
        source: "",
        qualification: "",
        dob: "",
        genderSelected: "",
        file: "",
        remarks: "",
        relevant_exp: null
    },
    isAddNewCandidateSidebarActive: false,
    error: {
      firstName: '',
      lastName: '',
      email: '',
      contact: '',
      exp: '',
      selectedCity: '',
      skillsSelected: '',
      qualification: '',
      source: '',
      genderSelected: '',
      companyName: '',
      jobTitle: '',
      ctc: '',
      expectedCTC: '',
      noticePeriod: '',
      file: ''
    },
    skillsOptions: [],
    loading: false,
    enabled: false,
    file: {},
    invalidFile : false,
    canHtmlRemarks: '',
    confirmRemark: false,
    remarks: [],
    checkButton: 'Check if Exist',

    };
  },
  
  created() {
    this.jobData = {
      id: this.$route.params.id,
      job_id: this.$route.query.job_id,
      position_name : this.$route.query.pname,
      client : this.$route.query.client,
      locations : this.$route.query.locations,
      account_mgr: this.$route.query.account_mgr,
      attachments: this.$route.query.attachments,
      sourcer: this.$route.query.sourcer,
      min_exp: parseFloat(this.$route.query.min_exp),
      max_exp: parseFloat(this.$route.query.max_exp),
      min_ctc: parseFloat(this.$route.query.min_ctc),
      max_ctc: parseFloat(this.$route.query.max_ctc),
      notice_period: parseInt(this.$route.query.notice_period)
    }
    if(this.jobData) {
      console.log(this.jobData)
      this.jId = this.jobData.id
      console.log(this.jId)
    }
    //this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
    this.candidateData.skillsSelected = [{ "title": this.jobData.position_name }]
    JobService.getJobPositionList().then(res => {
      console.log(res.data)
      this.skillsOptions = res.data
    })
    locationService.getAll().then(res => {
      console.log(res.data)
      this.cities = res.data
    })
  },
  methods: {  
    openFile(event) {
      console.log(event.target.files)
      if(event.target.files) {
        this.file = event.target.files[0];
        console.log("file", this.file);
        console.log("cfile", this.candidateData.file)
      } else {
        this.invalidFile = true
        console.log(this.invalidFile)
      }
    },
    formSubmitted() {
      this.loading = true
      console.log(this.candidateData)
      console.log('form check ', !this.candidateData.noticePeriod, !/[0-9]/i.test(this.candidateData.noticePeriod), !/[0-9]/i.test(this.candidateData.selectedCity), !/[0-9]/i.test(this.candidateData.preferredCities))
      const validation = this.validationForm();
      console.log(validation)
      if(this.confirmRemark === false) {
        this.hygieneCheck()
      }
      
      if(validation && this.confirmRemark) {
      const source = String(this.candidateData.source['title'])
      const qualification = String(this.candidateData.qualification['title'])
      //const noticePeriod = String(this.candidateData.noticePeriod['text'])
      const gender = String(this.candidateData.genderSelected['title'])
      const userData = JSON.parse(localStorage.getItem('userData'));
      const preCities = JSON.parse(JSON.stringify(this.candidateData.preferredCities)).map(({ title }) => title).join(',');
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
      const userRole = userData.roles[0]
      const username = `${userData.first_name} ${userData.last_name}`
      const useremail = userData.email

      //this.hygieneCheck(preCities,noticePeriod)

      const city = String(this.candidateData.selectedCity['title'])
      //const skills = String(this.candidateData.skillsSelected['title'])
      const skills = this.candidateData.skillsSelected[0].title
      console.log("title", this.candidateData.jobTitle)
      console.log("skills", skills, this.candidateData.skillsSelected)
      const formData = new FormData()
      formData.append('first_name', this.candidateData.firstName)
      formData.append('last_name', this.candidateData.lastName)
      formData.append('email', this.candidateData.email.toLowerCase())
      formData.append('curr_company', this.candidateData.companyName)
      formData.append('contact_no', parseInt(this.candidateData.contact))
      formData.append('curr_position', this.candidateData.jobTitle)
      formData.append('curr_location', city)
      formData.append('pref_location', preCities)
      formData.append('ctc', parseFloat(this.candidateData.ctc))
      formData.append('exp_ctc', parseFloat(this.candidateData.expectedCTC))
      formData.append('exp', parseFloat(this.candidateData.exp))
      formData.append('relevant_exp', parseFloat(this.candidateData.relevant_exp))
      formData.append('notice_period', this.candidateData.noticePeriod)
      // formData.append('contact_no', this.candidateData.contact)
      // formData.append('curr_position', this.candidateData.jobTitle)
      // formData.append('curr_location', city)
      // formData.append('pref_location', preCities)
      // formData.append('ctc', this.candidateData.ctc)
      // formData.append('exp_ctc', this.candidateData.expectedCTC)
      // formData.append('exp', this.candidateData.exp)
      // formData.append('relevant_exp', this.candidateData.relevant_exp)
      // formData.append('notice_period', noticePeriod)
      formData.append('skills', skills)
      formData.append('source', source)
      formData.append('qualification', qualification)
      formData.append('dob', this.candidateData.dob ? this.candidateData.dob : "1900-01-01")
      formData.append('gender', gender)
      formData.append('status', 'Uploaded')
      formData.append('created_by', user)
      formData.append('updated_by', user)
      formData.append('jobData', JSON.stringify(this.jobData))
      formData.append('can_remarks', JSON.stringify(this.remarks))
      // formData.append('sourcer', userData.emp_id)
      // formData.append('recruiter', userData.emp_id)
      formData.append('cvFile', this.candidateData.file)
      formData.append('remarks', this.candidateData.remarks)
      
      //const toast = useToast()
      console.log(formData)
      CandidateService.addCandidate(formData).then(res => {
        
        console.log(res)
        
        if(res.status === "OK") {
          
          if(this.jId) {
            
            console.log("position", res.data.curr_position)
            const candidate_id = res.data.candidate_id
            const cid = res.data.id
            const candidate_name = `${res.data.first_name} ${res.data.last_name}`
            const can_email = res.data.email
            const can_contact = res.data.contact_no
            const can_position = res.data.curr_position
            const can_company = res.data.curr_company
            const can_qualification = res.data.qualification
            const can_gender = res.data.gender
            const can_dob = res.data.dob
            const can_exp = res.data.exp
            const can_ctc = res.data.ctc
            const can_exp_ctc = res.data.exp_ctc
            const can_skills = res.data.skills
            const can_city = res.data.curr_location
            const can_pref_city = res.data.pref_location
            const can_notice_period = res.data.notice_period
            const cv_file = res.data.cv_path
            console.log("position", can_position)
            const c = [];
            c.push(cid)

            let candidateStatus = ''
            if (userRole === 'TALENT-ADVISOR') {
              candidateStatus = 'Initiated'
            }
            else if ( userRole === 'TALENT-ADVISOR-SOURCER') {
              console.log(this.sourcer)
              if(this.sourcer) {
                const isCurrentUserSourcer = this.sourcer.filter(item => item.emp_id === userData.emp_id)
                console.log(isCurrentUserSourcer)
                if(isCurrentUserSourcer) {
                  candidateStatus = 'ProfileShared'
                }
                else {
                  candidateStatus = 'Initiated'
                }
              } else {
                candidateStatus = 'Initiated'
              }

            } else {
              candidateStatus = 'ProfileShared'
            }
            const mgr = this.allUsers.filter(item => item.emp_id === userData.mgr_id)
            const data = {
              job_id: this.jId,
              candidate_id: c,
              candidateStatus: candidateStatus,
              source: res.data.source,
              addedBy: user,
              updatedBy: user,
              sourcer: userData.emp_id,
              recruiter: userData.emp_id,
              mgr_id: userData.mgr_id,
              p_mgr_id: mgr[0].manager,
              "Manager Name": userRole === 'TALENT-ADVISOR-SOURCER' ? mgr[0].title.toUpperCase() : username.toUpperCase(),
              "Employee Name": username.toUpperCase(),
            }
            console.log(data)
            JobService.assignCandidateToJob(data).then(res => {
              if(res.status === "OK") {
                const timelineData = {
                  title: `${candidate_id} - New Candidate - ${candidate_name} added`,
                  description: `New Candidate - Direct - CS-Changed`, /// CS-Changed means candidate status changed
                  type: "success",
                  createdBy: username,
                  jobId: this.jId,
                  candidate_id: cid,
                  candidateStatus: data.candidateStatus,
                  
                }
                console.log(timelineData);
              
                jobTimelineService.create(timelineData).then(res => {
                  
                  this.loading = false
                  console.log("timeline", res)
                  // Added exclusion for mail send on ProfileShared for client LTI RPO & Dummy
                  console.log( "client name", this.jobData.client )
                  if( data.candidateStatus === 'ProfileShared' && this.jobData.client!== 'LTI RPO' && this.jobData.client !== 'Dummy' && this.jobData.client !== 'Sonata Technologies' && this.jobData.client !== 'AXA XL-RR' && this.jobData.client !== 'Wipro RPO' && this.jobData.client !== 'Vector3 Digital Tech' && this.jobData.client !== 'Larsen & Toubro' && this.jobData.client !== 'Zamil Steel') {
                    console.log("in if mail")
                    const mailData = {
                      can_email: can_email,
                      can_fname: candidate_name,
                      can_contact: can_contact,
                      can_position: can_position,
                      can_company: can_company,
                      can_qualification: can_qualification,
                      can_gender: can_gender,
                      can_dob: can_dob == '1900-01-01' ? '' : can_dob,
                      can_exp: can_exp,
                      can_ctc: can_ctc,
                      can_exp_ctc: can_exp_ctc,
                      can_skills: can_skills,
                      can_city: can_city,
                      can_pref_city: can_pref_city,
                      can_notice_period: can_notice_period,
                      cv_file: cv_file,
                      rec_email: useremail,
                      position_name: this.jobData.position_name,
                      client: this.jobData.client,
                      location: this.jobData.locations,
                      am_email: this.jobData.account_mgr,
                      rec_name: username,
                      jd_file: this.jobData.attachments ? this.jobData.attachments : null//.replace("/","%2F")                     
                    }
                    console.log("in if mail-1", mailData)
                    let mail = ''
                        if (this.jobData.attachments) {
                          mail = emailTemplates.candidateProfileShared(mailData)
                        } else {
                          mail = emailTemplates.candidateProfileSharedNoJD(mailData)
                        }
                    console.log("in if mail-2", mail)
                    if (mail) {
                      mailService.mail(mail).then(res => {
                        console.log("in if mail-2", res)
                      })
                    }
                  } //Add logic to send push notifications
                   else if (data.candidateStatus === 'Initiated') {
                    console.log(this.jobData.account_mgr)
                    //const acc_mgr =  this.jobData.account_mgr[0].id
                    //console.log(acc_mgr)
                    // UserService.getToken(acc_mgr).then(res => {
                    //   console.log(res.data)
                    //   this.tokenData = res.data
                    //   //const client = JSON.parse(res.data.client)[0].title                     
                    //   for (let i=0; i < this.tokenData.length; i++) {

                    //     const payload = {
                    //           "notification": {
                    //             "title": `New Candidate Added By ${username} - ${this.jobData.position_name}`,
                    //             "body": `Your approval is required`,
                    //             /*dev*/"click_action": `https://localhost:8080/#/apps/candidates/view/${cid}/${this.jId}`,
                    //             /*prod*/ // "click_action": `https://ats.sattvahuman.in/#/apps/candidates/view/${cid}/${this.jobId}`,
                    //             "icon": "https://ats.sattvahuman.in/img/logo.77e558a1.svg"
                    //           },
                    //           "to": this.tokenData[i].fcm_token,
                    //           "priority": "high"
                    //       }
                    //       UserService.pushNotification(payload).then(res => {
                    //         console.log(res)
                            
                    //         firebaseMessaging.onMessage((payload) => {
                    //           console.log('Message received. ', payload);
                    //         });
                    //     })
                    //   }
                    // })
                  }
                  
                  


                })
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Candidate Added to the Job Successfully',
                    icon: 'EditIcon',
                    variant: 'success',
                    timeout: 5000,
                  },
                })
                
                //this.$router.push({ path: '/apps/view-job/' + data.job_id }).catch(() => {})
                this.$emit('refreshParent', true)
                this.resetData()
                this.$router.go(-1)

                //this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
                //window.location.reload();
              } else if ((res.status === 401 ) || (res.status === 403 )) {
                window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                localStorage.clear();
                this.$router.push({ name: "auth-login" });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Candidate Add to Job Failed !!!',
                    icon: 'EditIcon',
                    variant: 'danger',
                    timeout: 5000,
                  },
                })
                //this.$router.push({ path: '/apps/view-job/' + data.job_id }).catch(() => {})
                this.$emit('refreshParent', true)
                this.resetData()
                this.$router.go(-1)

                //this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
                //window.location.reload();
              }
            })
          }
          else{
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Candidate Added Successfully',
                icon: 'EditIcon',
                variant: 'success',
                timeout: 5000,
              },
            })
            this.$emit('refreshParent', true)
            //window.location.reload();
            this.resetData()
            this.$router.go(-1)
            //this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
          }
          //this.$router.push({ name: 'apps-candidates-list-all'}).catch(() => {})
          
          
          //return res.data          
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            this.error.file = 'Session Expired. Please Login again'
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else if (res.status === 413 || res.statusText === 'Request Entity Too Large') {
          this.loading = false
          this.error.file = 'File Size Too Large! Kindly compress and reupload'
        } else if (res.status === 413) {
          this.loading = false
            this.error.file = 'File Size is greater than 1 mb Kindly compress and reupload'
        } else if (res.status === 502) {
          this.loading = false
            this.error.file = 'Aargh!! looks like something is not right, Please wait for 1 minute and try clicking add again.'
        } 
        else if (res.status === 500 ) {
          console.log(res.data)
          this.loading = false
          if (JSON.stringify(res.data).includes('Validation error')) {
            console.log(res.data.error, res.data.error.errors[0])  
            let msg = res.data.error.errors[0].message
            console.log(msg)
            const msg1 = "To assign this Candidate in this Job, click on Assign Candidates Tab, search the Candidate and on right hand side click on three dots for the searched candidate and click on Assign to This Job"
            this.loading = false
            if(msg === "email must be unique") {
              msg = "Email already exists!"
              this.error.email = "Duplicate! Email Already exists!" + msg1
            } else if (msg === "contact_no must be unique") {
              msg = "Contact No already exists!"
              this.error.contact = "Duplicate! Contact No Already exists!"  + msg1
            } else {
              this.error.file = msg
            }  

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Candidate Add Failed ' + msg,
                icon: 'EditIcon',
                variant: 'danger',
                timeout: 5000,
              },
            })
            
            //this.$router.push({ name: 'apps-candidates-list-all'}).catch(() => {})
              //this.$emit('refreshParent', true)
              //window.location.reload();
              //this.resetData()
              //this.$router.go(-1)
              //this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
            //window.location.reload();
            return msg
          } else if (JSON.stringify(res.data).includes('File too large')) {
            this.error.file = 'File Size Too Large! Kindly compress and reupload'
          }
          else {
            this.error.file = res
          } 
        } else {
          this.error.file = res
        } 
      })
      }
    },
    validateEmail(email){
      return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    closeToggle() {
      console.log("called")
      this.loading = false
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    resetData() {
      this.candidateData = {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact: "",
        jobTitle: "",
        selectedCity: "",
        preferredCities: "",
        ctc: "",
        expectedCTC: "",
        exp: "",
        noticePeriod: "",
        skillsSelected: "",
        source: "",
        qualification: "",
        dob: "",
        genderSelected: "",
        file: "",
        remarks: ""
      }
      this.error = {
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        exp: '',
        selectedCity: '',
        preferredCities: '',
        skillsSelected: '',
        qualification: '',
        source: '',
        genderSelected: '',
        dob: '',
        companyName: '',
        jobTitle: '',
        ctc: '',
        expectedCTC: '',
        noticePeriod: '',
        file: '',
        remarks: ''
      }
    },
    hygieneCheck() {
      this.remarks = []
      // if (this.candidateData.exp && (this.candidateData.exp >= this.jobData.min_exp || this.candidateData.exp <= this.jobData.max_exp)) {
      //     remarks.push(`Candidate Experience(${this.candidateData.exp} Years) does not lie between Minimum (${this.jobData.min_exp}) & Maximum (${this.jobData.max_exp}) Experience Required for this job.`)
      // }
      // if (this.candidateData.relevant_exp && (this.candidateData.relevant_exp >= this.jobData.min_exp || this.candidateData.relevant_exp <= this.jobData.max_exp)) {
      //     remarks.push(`Candidate Relevant Experience (${this.candidateData.relevant_exp} Years) does not lie between Minimum (${this.jobData.min_exp}) & Maximum (${this.jobData.max_exp}) Experience Required for this job.`)
      // }
      const noticePeriod = this.candidateData.noticePeriod
      const preCities = JSON.parse(JSON.stringify(this.candidateData.preferredCities)).map(({ title }) => title).join(',');
      if (this.candidateData.expectedCTC && (this.candidateData.expectedCTC > this.jobData.max_ctc)) {
          this.remarks.push(`Candidate Expected CTC (${this.candidateData.expectedCTC} Lacs) exceeds Maximum (${this.jobData.max_ctc}) CTC offerered for this job.`)
      }
      if (noticePeriod && (noticePeriod > this.jobData.notice_period)) {
          this.remarks.push(`Candidate Notice Period (${noticePeriod} Days) is greater than Maximum Notice Period (${this.jobData.notice_period} Days) Required for this job.`)
      }

      if (preCities && !this.jobData.locations.includes('Remote')) {
          let location_match = false
          let pref_location = [], locations = []
          // if (preCities.includes(',')) 
          // { 
          pref_location = preCities.split(",") 
          // }
          // if (this.jobData.locations.includes(',')) 
          // { 
          locations = this.jobData.locations.split(",") 
          //}
          location_match = locations.some(item => pref_location.includes(item));
          if (!location_match) {
            this.remarks.push(`Candidate Preferred Locations (${preCities}) does not match the Locations (${this.jobData.locations}) available for this job.`)
          }
      }
      if(this.remarks.length > 0) {
        this.$refs['can-remarks-check'].show()
      } else {
        this.confirmRemark = true
        //this.formSubmitted()
      }
      //this.formSubmitted()
      //return this.confirmRemark
    },
    confirmRemarks() {
      this.confirmRemark = true
      this.formSubmitted()
    },
    checkCandidateExist() {
      if(this.candidateData.email && this.candidateData.contact) {
        if(this.validateEmail(this.candidateData.email) && this.candidateData.contact.length === 10) {
          CandidateService.checkCandidateExist(this.candidateData.email, this.candidateData.contact).then(res => {
            console.log(res)
            // res is either res.data (200 path) or err.response (400 path — backend bug)
            const body = res.data || res
            if (body.data && body.data.length > 0) {
              this.error.email = 'Candidate Already Exist in ATS'
              this.checkButton = 'Check if Exist'
            } else {
              this.checkButton = 'Fresh Candidate'
              this.error.email = null
              this.error.contact = null
            }
          })
        } else {
          this.error.email = 'Please enter valid email'
          this.error.contact = 'Please enter valid contact number 10 digit'
          this.checkButton = null
        }
      } else if (!this.candidateData.email || !this.candidateData.contact) {
        if (!this.candidateData.email || !this.validateEmail(this.candidateData.email)) {
          this.error.email = 'Please enter valid email'
        }
        if (!this.candidateData.contact || !this.candidateData.contact.length !== 10) {
          this.error.contact = 'Please enter valid contact no(10 digits required)'
        }
      } 
    },
    clearError(field) {
      if (this.error[field]) this.error[field] = null
    },
    runCheck() {
      console.log('in check')
      this.checkCandidateExist()
    },  
    validationForm() {
      if(!this.candidateData.firstName) {
        this.error.firstName="First Name is Mandatory"
        this.$nextTick(() => {
          this.$refs.firstName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.lastName) {
        this.error.lastName="Last Name is Mandatory"
        this.$nextTick(() => {
          this.$refs.lastName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.companyName) {
        this.error.companyName="Company Name is Mandatory, use NA for freshers"
        this.$nextTick(() => {
          this.$refs.companyName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.jobTitle) {
        this.error.jobTitle="Job Title is Mandatory, use NA for freshers"
        this.$nextTick(() => {
          this.$refs.jobTitle.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      
      if(!this.candidateData.email || !this.validateEmail(this.candidateData.email)) {
        
        this.error.email ="Mandatory Field/Email is Invalid"
        this.$nextTick(() => {
          this.$refs.email.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.contact || this.candidateData.contact.length !== 10) {
        
        if(this.candidateData.contact.length !== 10) {
          this.error.contact="Contact No should be 10 digits"
        } else {
          this.error.contact="Contact No is Mandatory"
        }
        this.$nextTick(() => {
          this.$refs.contact.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.ctc) {
        this.error.ctc="CTC is Mandatory, use 0 for freshers"
        this.$nextTick(() => {
          this.$refs.ctc.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.expectedCTC) {
        this.error.expectedCTC="Expected CTC is Mandatory"
        this.$nextTick(() => {
          this.$refs.expectedCTC.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.noticePeriod || !/[0-9]/i.test(this.candidateData.noticePeriod)) {
        this.error.noticePeriod="Notice Period is Mandatory, use Immediate for freshers"
        // this.$nextTick(() => {
        //   this.$refs.noticePeriod.focus()
        // })
        console.log("this", /[0-9]/i.test(this.candidateData.noticePeriod), /[a-z]/i.test(this.candidateData.selectedCity))
        this.loading = false
        return false
      }
      if(!this.candidateData.exp) {
        this.error.exp="Experience is Mandatory(if fresher mention 0)"
        this.$nextTick(() => {
          this.$refs.exp.focus()
        })
        this.loading = false
        return false
      }
      if(!this.candidateData.selectedCity || !/[a-z]/i.test(this.candidateData.selectedCity)) {
        this.error.selectedCity="City is Mandatory"
        // this.$nextTick(() => {
        //   this.$refs.city.focus()
        // })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.preferredCities || !/[a-z]/i.test(this.candidateData.preferredCities)) {
        this.error.preferredCities="Preferred Location is Mandatory"
        this.$nextTick(() => {
          this.$refs.preCity.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.skillsSelected) {
        this.error.skillsSelected="Skills is Mandatory"
        // this.$nextTick(() => {
        //   this.$refs.skills.focus()
        // })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.qualification || !/[a-z]/i.test(this.candidateData.qualification)) {
        this.error.qualification="Qualification is Mandatory"
        // this.$nextTick(() => {
        //   this.$refs.qualification.focus()
        // })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.source || !/[a-z]/i.test(this.candidateData.source)) {
        this.error.source="Source is Mandatory"
        // this.$nextTick(() => {
        //   this.$refs.source.focus()
        // })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.genderSelected || !/[a-z]/i.test(this.candidateData.genderSelected)) {
        this.error.gender="Gender is Mandatory"
        
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.file || !this.file || this.invalidFile) {
        if(this.invalidFile) {
          this.error.file="Not a Vaild File"  
        } else {
          this.error.file="Resume/CV is Mandatory"
          console.log("this")
          this.loading = false
        }
        return false
      }
      return true
      
      
    }

  },
  mounted() {
    adminConfigService.getATSDropdownList().then(res => {
      console.log('ats dropdown: ',res.data)
      if(res.status === 200) {
        this.sources = res.data.data.sourceList
        this.qualifications = res.data.data.qualificationList
      }
    })
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-candidate-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.b-sidebar.sidebar-lg {
  width: 45rem;
  padding-left: 15px;
  padding-right: 15px;
}
.hidden{
  display: none;
}
</style>
